import React, { useState, useRef } from 'react';
import { ArrowRightIcon } from 'lucide-react';
const SubscriptionBanner = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [isHovering, setIsHovering] = useState(false);
  const emailRef = useRef(null);
  const validateEmail = value => {
    if (!value) {
      setError('');
      return;
    }
    if (!value.includes('@')) {
      setError(`Please include an '@' in the email address. '${value}' is missing an '@'.`);
    } else {
      setError('');
    }
  };
  const handleEmailChange = e => {
    const value = e.target.value;
    setEmail(value);
    validateEmail(value);
  };
  const handleSubmit = e => {
    e.preventDefault();
    if (!email) {
      setError('Please fill out this field.');
      return;
    }
    if (!email.includes('@')) {
      setError(`Please include an '@' in the email address. '${email}' is missing an '@'.`);
      return;
    }
    // Here you would typically send the email to your backend
    alert(`Thank you for subscribing with: ${email}`);
    setEmail('');
    setError('');
  };
  return <section className="py-12 md:py-14 bg-gradient-to-br from-[#E87B5C] to-[#D16A4A] text-white" data-id="element-488">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-489">
        <h2 className="text-2xl md:text-3xl font-bold mb-6" data-id="element-490">
          Receive New Updates From Us!
        </h2>
        <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-4 max-w-lg mx-auto" data-id="element-491">
          <div className="relative flex-grow" data-id="element-492">
            <input ref={emailRef} type="email" value={email} onChange={handleEmailChange} onMouseEnter={() => setIsHovering(true)} onMouseLeave={() => setIsHovering(false)} className="w-full px-4 py-3 rounded-lg text-gray-800 focus:outline-none focus:ring-2 focus:ring-white" placeholder="Email Address" autoComplete="email" data-id="element-493" />
            {/* Hover tooltip */}
            {isHovering && !email && <div className="absolute -top-10 left-0 bg-gray-800 text-white text-sm px-3 py-1 rounded" data-id="element-494">
                Please fill out this field.
                <div className="absolute -bottom-1 left-4 w-2 h-2 bg-gray-800 transform rotate-45" data-id="element-495"></div>
              </div>}
            {/* Error message */}
            {error && <div className="absolute -bottom-8 left-0 text-sm text-white bg-red-600 px-2 py-1 rounded" data-id="element-496">
                {error}
              </div>}
          </div>
          <button type="submit" className="bg-white text-[#E87B5C] px-6 py-3 rounded-lg font-medium hover:bg-gray-100 transition-colors flex items-center justify-center" data-id="element-497">
            Subscribe
            <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-498" />
          </button>
        </form>
      </div>
    </section>;
};
export default SubscriptionBanner;